module.exports = {
	"config": {
		"siteTitle": "Reindex",
		"rootURL": "https://www.reindex.io",
		"auth0ClientId": "Oo3B84pCuAvHE3bdI61uGZtOh5v4q9Ne",
		"auth0Domain": "reindex.eu.auth0.com",
		"auth0CallbackUrl": "https://accounts.reindex.io/callback"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"dirname": ".",
				"basename": "_RelaySample.md",
				"name": "_RelaySample",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "_RelaySample.md",
			"data": {}
		},
		{
			"file": {
				"dirname": ".",
				"basename": "_template.jsx",
				"name": "_template",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "/./"
		},
		{
			"file": {
				"dirname": ".",
				"basename": "404.html",
				"name": "404",
				"extname": ".html",
				"extSegments": [
					".html"
				],
				"ext": "html"
			},
			"requirePath": "404.html",
			"data": "<div style=\"text-align: center\">\n  <h1>404 – Not Found</h1>\n  <p>\n    We could not find a page in this URI.<br>\n    Try the <a href=\"/\">home page</a> instead?\n  </p>\n</div>\n",
			"path": "/404/"
		},
		{
			"file": {
				"dirname": "blog",
				"basename": "_template.jsx",
				"name": "_template",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "blog/_template.jsx",
			"templatePath": "/blog/"
		},
		{
			"file": {
				"dirname": "blog/auth0-and-reindex",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "blog/auth0-and-reindex/index.md",
			"data": {
				"layout": "post",
				"title": "Using Auth0 with Reindex",
				"author": {
					"name": "Mikhail Novikov",
					"image": "https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg",
					"link": "https://twitter.com/freiksenet",
					"twitter": "freiksenet",
					"bio": "CTO & Co-founder"
				},
				"date": "2016-05-24T12:39:00.000Z",
				"categories": [
					"React",
					"React Native",
					"Auth0"
				],
				"excerpt": "Auth0 is a great service to handle your authentication. In this arcticle we will show how to use Auth0 with Reindex, React and React Native",
				"image": "/blog/auth0-and-reindex/auth0-and-reindex.png"
			},
			"path": "/blog/auth0-and-reindex/"
		},
		{
			"file": {
				"dirname": "blog/building-a-graphql-server-with-node-js-and-sql",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "blog/building-a-graphql-server-with-node-js-and-sql/index.md",
			"data": {
				"layout": "post",
				"title": "Building a GraphQL Server with Node.js and SQL",
				"author": {
					"name": "Mikhail Novikov",
					"image": "https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg",
					"link": "https://twitter.com/freiksenet",
					"twitter": "freiksenet",
					"bio": "CTO & Co-founder"
				},
				"date": "2015-08-03T08:51:55.000Z",
				"categories": [
					"GraphQL",
					"JavaScript",
					"Open Source"
				],
				"excerpt": "GraphQL is a new technology from Facebook. It aims to replace REST as a go-to API standard for developing rich applications. In this article we'll build a simple GraphQL server using Node.js and an SQL database.",
				"image": "/blog/building-a-graphql-server-with-node-js-and-sql/GraphQL_NodeJS.png"
			},
			"path": "/blog/building-a-graphql-server-with-node-js-and-sql/"
		},
		{
			"file": {
				"dirname": "blog/discontinuing-backend-as-a-service",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "blog/discontinuing-backend-as-a-service/index.md",
			"data": {
				"layout": "post",
				"title": "Discontinuing Reindex Backend as a Service",
				"author": {
					"name": "Ville Immonen",
					"image": "https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg",
					"link": "https://twitter.com/VilleImmonen",
					"twitter": "VilleImmonen",
					"bio": "CEO & Co-founder"
				},
				"date": "2017-09-20T11:30:00.000Z",
				"categories": [
					"Reindex",
					"GraphQL",
					"News"
				],
				"excerpt": "Two and half years ago we started developing Reindex, the first backend as a service with a GraphQL API. Now we're moving on."
			},
			"path": "/blog/discontinuing-backend-as-a-service/"
		},
		{
			"file": {
				"dirname": "blog/graphql-shopping-cart-api",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "blog/graphql-shopping-cart-api/index.md",
			"data": {
				"layout": "post",
				"title": "Build a GraphQL shopping cart API with Reindex",
				"author": {
					"name": "Ville Immonen",
					"image": "https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg",
					"link": "https://twitter.com/VilleImmonen",
					"twitter": "VilleImmonen",
					"bio": "CEO & Co-founder"
				},
				"date": "2016-05-11T12:40:00.000Z",
				"categories": [
					"Reindex",
					"tutorial",
					"e-commerce",
					"permissions"
				],
				"excerpt": "Build a secure shopping cart API with server-side storage and permissions using Reindex.",
				"image": "/blog/graphql-shopping-cart-api/graphql-shopping-cart.png"
			},
			"path": "/blog/graphql-shopping-cart-api/"
		},
		{
			"file": {
				"dirname": "blog/how-facebooks-graphql-will-change-backend-development",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "blog/how-facebooks-graphql-will-change-backend-development/index.md",
			"data": {
				"layout": "post",
				"title": "How Facebook's GraphQL Will Change Backend Development",
				"author": {
					"name": "Ville Immonen",
					"image": "https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg",
					"link": "https://twitter.com/VilleImmonen",
					"twitter": "VilleImmonen",
					"bio": "CEO & Co-founder"
				},
				"date": "2015-04-27T15:45:26.000Z",
				"categories": [
					"GraphQL",
					"Open Source",
					"Web"
				],
				"excerpt": "Why we're excited about GraphQL, the data query language for fetching data in mobile and web apps?",
				"image": "/blog/how-facebooks-graphql-will-change-backend-development/GraphQL_logo.png"
			},
			"path": "/blog/how-facebooks-graphql-will-change-backend-development/"
		},
		{
			"file": {
				"dirname": "blog",
				"basename": "index.jsx",
				"name": "index",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "blog/index.jsx",
			"path": "/blog/"
		},
		{
			"file": {
				"dirname": "blog/redux-and-relay",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "blog/redux-and-relay/index.md",
			"data": {
				"layout": "post",
				"title": "Comparing Redux and Relay",
				"author": {
					"name": "Mikhail Novikov",
					"image": "https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg",
					"link": "https://twitter.com/freiksenet",
					"twitter": "freiksenet",
					"bio": "CTO & Co-founder"
				},
				"date": "2016-04-29T22:59:00.000Z",
				"categories": [
					"React",
					"Relay",
					"Flux",
					"Redux",
					"JavaScript",
					"GraphQL"
				],
				"excerpt": "Relay and Redux are both state-of-the-art client-side state management libraries for React. In this article we compare the approaches Relay and Redux take and their strengths and weaknesses.",
				"image": "/blog/redux-and-relay/redux-and-relay.png"
			},
			"path": "/blog/redux-and-relay/"
		},
		{
			"file": {
				"dirname": "blog/relay-graphql-pagination-with-mongodb",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "blog/relay-graphql-pagination-with-mongodb/index.md",
			"data": {
				"layout": "post",
				"title": "Relay-compatible GraphQL pagination with MongoDB",
				"author": {
					"name": "Mikhail Novikov",
					"image": "https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg",
					"link": "https://twitter.com/freiksenet",
					"twitter": "freiksenet",
					"bio": "CTO & Co-founder"
				},
				"date": "2016-07-26T12:39:00.000Z",
				"categories": [
					"Relay",
					"GraphQL",
					"MongoDB"
				],
				"excerpt": "In this article I will show how to create a GraphQL server with Relay-compatible pagination using MongoDB"
			},
			"path": "/blog/relay-graphql-pagination-with-mongodb/"
		},
		{
			"file": {
				"dirname": "blog/releasing-reindex-graphql-backend-as-a-service",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "blog/releasing-reindex-graphql-backend-as-a-service/index.md",
			"data": {
				"layout": "post",
				"title": "Releasing Reindex, the GraphQL backend as a service",
				"author": {
					"name": "Ville Immonen",
					"image": "https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg",
					"link": "https://twitter.com/VilleImmonen",
					"twitter": "VilleImmonen",
					"bio": "CEO & Co-founder"
				},
				"date": "2016-01-26T19:00:00.000Z",
				"categories": [
					"Reindex",
					"GraphQL",
					"News"
				],
				"excerpt": "Reindex is available now, time to start building serverless apps with GraphQL!",
				"image": "/blog/releasing-reindex-graphql-backend-as-a-service/illustration-nobg.png"
			},
			"path": "/blog/releasing-reindex-graphql-backend-as-a-service/"
		},
		{
			"file": {
				"dirname": "blog/you-might-not-need-underscore",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "blog/you-might-not-need-underscore/index.md",
			"data": {
				"layout": "post",
				"title": "You Might Not Need Underscore",
				"author": {
					"name": "Ville Immonen",
					"image": "https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg",
					"link": "https://twitter.com/VilleImmonen",
					"twitter": "VilleImmonen",
					"bio": "CEO & Co-founder"
				},
				"date": "2015-06-28T22:26:11.000Z",
				"categories": [
					"JavaScript"
				],
				"excerpt": "Latest features of JavaScript are now easy to use with Babel. We show how you can use the standard JavaScript features to do tasks that previously required a utility library to do without lots of code.",
				"image": "/blog/you-might-not-need-underscore/ES_evolution1.png"
			},
			"path": "/blog/you-might-not-need-underscore/"
		},
		{
			"file": {
				"dirname": "docs",
				"basename": "_template.jsx",
				"name": "_template",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/"
		},
		{
			"file": {
				"dirname": "docs/graphql-api",
				"basename": "built-in-types.md",
				"name": "built-in-types",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/graphql-api/built-in-types.md",
			"data": {
				"title": "Built-in types",
				"order": 4
			},
			"path": "/docs/graphql-api/built-in-types/"
		},
		{
			"file": {
				"dirname": "docs/graphql-api",
				"basename": "connections.md",
				"name": "connections",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/graphql-api/connections.md",
			"data": {
				"title": "Connections",
				"order": 3
			},
			"path": "/docs/graphql-api/connections/"
		},
		{
			"file": {
				"dirname": "docs/graphql-api",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/graphql-api/index.md",
			"data": {
				"title": "GraphQL API",
				"order": 3
			},
			"path": "/docs/graphql-api/"
		},
		{
			"file": {
				"dirname": "docs/graphql-api",
				"basename": "mutations.md",
				"name": "mutations",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/graphql-api/mutations.md",
			"data": {
				"title": "Mutations",
				"order": 2
			},
			"path": "/docs/graphql-api/mutations/"
		},
		{
			"file": {
				"dirname": "docs/graphql-api",
				"basename": "queries.md",
				"name": "queries",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/graphql-api/queries.md",
			"data": {
				"title": "Queries",
				"order": 1
			},
			"path": "/docs/graphql-api/queries/"
		},
		{
			"file": {
				"dirname": "docs/importing-data",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/importing-data/index.md",
			"data": {
				"title": "Importing data",
				"order": 6
			},
			"path": "/docs/importing-data/"
		},
		{
			"file": {
				"dirname": "docs",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/index.md",
			"data": {
				"title": "Introduction",
				"order": 0
			},
			"path": "/docs/"
		},
		{
			"file": {
				"dirname": "docs/integrations",
				"basename": "emails.md",
				"name": "emails",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/integrations/emails.md",
			"data": {
				"title": "Sending emails",
				"order": 3
			},
			"path": "/docs/integrations/emails/"
		},
		{
			"file": {
				"dirname": "docs/integrations",
				"basename": "hooks.md",
				"name": "hooks",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/integrations/hooks.md",
			"data": {
				"title": "Hooks",
				"order": 1
			},
			"path": "/docs/integrations/hooks/"
		},
		{
			"file": {
				"dirname": "docs/integrations",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/integrations/index.md",
			"data": {
				"title": "Integrating third-party services",
				"order": 6
			},
			"path": "/docs/integrations/"
		},
		{
			"file": {
				"dirname": "docs/reindex-cli",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/reindex-cli/index.md",
			"data": {
				"title": "Reindex CLI",
				"order": 9
			},
			"path": "/docs/reindex-cli/"
		},
		{
			"file": {
				"dirname": "docs/reindex-js",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/reindex-js/index.md",
			"data": {
				"title": "reindex-js",
				"order": 8
			},
			"path": "/docs/reindex-js/"
		},
		{
			"file": {
				"dirname": "docs/reindex-schema",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/reindex-schema/index.md",
			"data": {
				"title": "Reindex schema",
				"order": 2
			},
			"path": "/docs/reindex-schema/"
		},
		{
			"file": {
				"dirname": "docs/security",
				"basename": "authentication.md",
				"name": "authentication",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/security/authentication.md",
			"data": {
				"title": "Authentication",
				"order": 1
			},
			"path": "/docs/security/authentication/"
		},
		{
			"file": {
				"dirname": "docs/security",
				"basename": "authorization.md",
				"name": "authorization",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/security/authorization.md",
			"data": {
				"title": "Authorization",
				"order": 2
			},
			"path": "/docs/security/authorization/"
		},
		{
			"file": {
				"dirname": "docs/security",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/security/index.md",
			"data": {
				"title": "Security",
				"order": 5
			},
			"path": "/docs/security/"
		},
		{
			"file": {
				"dirname": "docs/tutorial",
				"basename": "adding-mutations.md",
				"name": "adding-mutations",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/tutorial/adding-mutations.md",
			"data": {
				"title": "Adding mutations",
				"order": 4
			},
			"path": "/docs/tutorial/adding-mutations/"
		},
		{
			"file": {
				"dirname": "docs/tutorial",
				"basename": "authenticating-users.md",
				"name": "authenticating-users",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/tutorial/authenticating-users.md",
			"data": {
				"title": "Authenticating users",
				"order": 6
			},
			"path": "/docs/tutorial/authenticating-users/"
		},
		{
			"file": {
				"dirname": "docs/tutorial",
				"basename": "defining-the-schema.md",
				"name": "defining-the-schema",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/tutorial/defining-the-schema.md",
			"data": {
				"title": "Defining the schema",
				"order": 2
			},
			"path": "/docs/tutorial/defining-the-schema/"
		},
		{
			"file": {
				"dirname": "docs/tutorial",
				"basename": "deployment.md",
				"name": "deployment",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/tutorial/deployment.md",
			"data": {
				"title": "Deployment",
				"order": 5
			},
			"path": "/docs/tutorial/deployment/"
		},
		{
			"file": {
				"dirname": "docs/tutorial",
				"basename": "displaying-todos.md",
				"name": "displaying-todos",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/tutorial/displaying-todos.md",
			"data": {
				"title": "Displaying todos",
				"order": 3
			},
			"path": "/docs/tutorial/displaying-todos/"
		},
		{
			"file": {
				"dirname": "docs/tutorial",
				"basename": "index.md",
				"name": "index",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/tutorial/index.md",
			"data": {
				"title": "Tutorial",
				"order": 1
			},
			"path": "/docs/tutorial/"
		},
		{
			"file": {
				"dirname": "docs/tutorial",
				"basename": "setup.md",
				"name": "setup",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "docs/tutorial/setup.md",
			"data": {
				"title": "Setup",
				"order": 1
			},
			"path": "/docs/tutorial/setup/"
		},
		{
			"file": {
				"dirname": ".",
				"basename": "index.jsx",
				"name": "index",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "index.jsx",
			"path": "/"
		},
		{
			"file": {
				"dirname": "policies",
				"basename": "_template.jsx",
				"name": "_template",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "policies/_template.jsx",
			"templatePath": "/policies/"
		},
		{
			"file": {
				"dirname": "policies",
				"basename": "open-source.md",
				"name": "open-source",
				"extname": ".md",
				"extSegments": [
					".md"
				],
				"ext": "md"
			},
			"requirePath": "policies/open-source.md",
			"data": {},
			"path": "/policies/open-source/"
		},
		{
			"file": {
				"dirname": "policies",
				"basename": "privacy-policy.html",
				"name": "privacy-policy",
				"extname": ".html",
				"extSegments": [
					".html"
				],
				"ext": "html"
			},
			"requirePath": "policies/privacy-policy.html",
			"data": "<a\n  href=\"https://www.iubenda.com/privacy-policy/7763734\"\n  class=\"iubenda-nostyle no-brand iub-body-embed iubenda-embed\"\n  title=\"Privacy Policy\">\n  Privacy Policy\n</a>\n",
			"path": "/policies/privacy-policy/"
		},
		{
			"file": {
				"dirname": "policies",
				"basename": "terms-and-conditions.html",
				"name": "terms-and-conditions",
				"extname": ".html",
				"extSegments": [
					".html"
				],
				"ext": "html"
			},
			"requirePath": "policies/terms-and-conditions.html",
			"data": "<a\n  href=\"https://www.iubenda.com/terms-and-conditions/7763742\"\n  class=\"iubenda-nostyle no-brand iub-body-embed iubenda-embed\"\n  title=\"Terms and Conditions\">\n  Terms and Conditions\n</a>\n",
			"path": "/policies/terms-and-conditions/"
		},
		{
			"file": {
				"dirname": ".",
				"basename": "team.jsx",
				"name": "team",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "team.jsx",
			"path": "/team/"
		},
		{
			"file": {
				"dirname": "ui",
				"basename": "_Button.jsx",
				"name": "_Button",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "ui/_Button.jsx"
		},
		{
			"file": {
				"dirname": "ui",
				"basename": "_HeaderButton.jsx",
				"name": "_HeaderButton",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "ui/_HeaderButton.jsx"
		},
		{
			"file": {
				"dirname": "ui",
				"basename": "_Logo.jsx",
				"name": "_Logo",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "ui/_Logo.jsx"
		},
		{
			"file": {
				"dirname": "ui",
				"basename": "_MailingListSignupForm.jsx",
				"name": "_MailingListSignupForm",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "ui/_MailingListSignupForm.jsx"
		},
		{
			"file": {
				"dirname": "ui",
				"basename": "_ReindexTypography.jsx",
				"name": "_ReindexTypography",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "ui/_ReindexTypography.jsx"
		},
		{
			"file": {
				"dirname": "ui",
				"basename": "_TwitterFollowButton.jsx",
				"name": "_TwitterFollowButton",
				"extname": ".jsx",
				"extSegments": [
					".jsx"
				],
				"ext": "jsx"
			},
			"requirePath": "ui/_TwitterFollowButton.jsx"
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 258
 ** module chunks = 0
 **/